<div class="errorContent">
    <div class="shadowBox">
        <div class="errorInner text-center rd"><span class="iconBg"><span class="cgx-i cgx-i_LockedAccount"></span></span>
            <h1 class="pageTitle02">Thank you</h1>
            <h2 class="subTitle01-2">Your session has been logged out.</h2>
            <div class="formRow">
                <button (click)="login()"> <span>back to login</span></button>
            </div>
        </div>
    </div>
</div>
